import {
    validateAppointmentType,
    validateDate,
    validateEndTime,
    validateLocation,
    validateReferralDate,
    validateRemoteCallUrl,
    validateStartTime
} from './validationFunctions';

export const validate = (newEntry, referralDate = '') => {
    let newErrors = {};
    newErrors = validateAppointmentType(newEntry.typeId, newErrors);
    newErrors = validateLocation(newEntry.locationId, newErrors);
    newErrors = newEntry.remoteCallUrl
        ? validateRemoteCallUrl(newEntry.remoteCallUrl, newErrors)
        : newErrors;
    newErrors = validateStartTime(newEntry.startTime, newEntry.endTime, newErrors);
    newErrors = validateEndTime(newEntry.endTime, newEntry.startTime, newErrors);
    newErrors = validateDate(newEntry.date, newErrors);
    if (newEntry.date) newErrors = validateReferralDate(newEntry.date, newErrors, referralDate);

    return newErrors;
};
